export default "__VITE_ASSET__BB$8fZFn__"